
<template>
    <div>
        <template v-if="today_attendance === true && attendance !== null" >
            <!-- Modal -->
            <div class="modal fade" id="absenteesModal" tabindex="-1" role="dialog" aria-labelledby="absenteesModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                        <div class="modal-body abentess-popup pr-0 pt-4 pl-0 pt-3 pb-3">
                            <table id="dt-absentees" class="table" style="width:100%">
                                <thead>
                                    <tr>
                                        <th style="width: 25px !important;"></th>
                                        <th>Name</th>
                                        <th>Arrival</th>
                                        <th>Departure</th>
                                    </tr>
                                </thead>
                                <tbody v-if="attendance.AbsenteesEmployee.length > 0">
                                    <tr v-for="ab in attendance.AbsenteesEmployee" :key="ab.id">
                                        <td style="width: 25px !important;">
                                            <input hidden type="checkbox" name="absentUpdate[]" :value="ab.id">
                                        </td>
                                        <td class="">
                                            <div class="image-title">
                                                <div class="image-holder entity-detail-tooltip" data-toggle="tooltip">
                                                 <img :src="'/avatar/'+ab.avatar" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                                                </div>
                                                {{ab.name}}
                                            </div>
                                        </td>
                                        <td>
                                            <div class="absentess-col-main clearfix">
                                                <div class="absentess-col">
                                                    <select class="form-control custom-select" data-size="7" :id="`absentTimeInHour${ab.id}`" name="absentTimeInHour[]">
                                                        <option value="">--</option>
                                                        <option v-for="i in 12 " :value="i">{{(i < 10) ? '0'+i : i}}</option>
                                                    </select>
                                                </div>
                                                <div class="absentess-col">
                                                    <select class="form-control custom-select" data-size="7" :id="`absentTimeInMinute${ab.id}`" name="absentTimeInMinute[]">
                                                        <option value="">--</option>
                                                        <option v-for="(i,index) in 60" :value="index">{{(index < 10) ? '0'+index : index}}</option>
                                                    </select>
                                                </div>
                                                <div class="absentess-col">
                                                    <select class="form-control custom-select" :id="`absentTimeInAMPM${ab.id}`" name="absentTimeInAMPM[]">
                                                        <option value="">--</option>
                                                        <option value="AM">AM</option>
                                                        <option value="PM">PM</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="absentess-col-main clearfix">
                                                <div class="absentess-col">
                                                    <select class="form-control custom-select" data-size="7" :id="`absentTimeOutHour${ab.id}`" name="absentTimeOutHour[]">
                                                        <option value="">--</option>
                                                        <option v-for="i in 12 " :value="i">{{(i < 10) ? '0'+i : i}}</option>
                                                    </select>
                                                </div>
                                                <div class="absentess-col">
                                                    <select class="form-control custom-select" data-size="7" :id="`absentTimeOutMinute${ab.id}`" ame="absentTimeOutMinute[]">
                                                        <option value="">--</option>
                                                        <option v-for="(i,index) in 60" :value="index">{{(index < 10) ? '0'+index : index}}</option>
                                                    </select>
                                                </div>
                                                <div class="absentess-col">
                                                    <select class="form-control custom-select" :id="`absentTimeOutAMPM${ab.id}`" name="absentTimeOutAMPM[]">
                                                        <option value="">--</option>
                                                        <option value="AM">AM</option>
                                                        <option value="PM">PM</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr>
                                        <td>No Record Found.</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="text-right p-3">
                                <button type="button" class="btn btn-primary" @click="updateAbsentees()" data-dismiss="modal" aria-label="Close">
                                Update
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Absentess End-->
            <!-- Modal -->
            <div class="modal fade" id="view-attendanceModal" tabindex="-1" role="dialog" aria-labelledby="view-attendanceModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                        <form @submit.prevent="updateAttendanceCorrection(popupData.id)" id="attendance_correction">
                            <div class="modal-body view-attendance-popup p-0">
                                <div class="view-attendance-content">
                                    <div class="head clearfix">
                                        <div class="image-holder">
                                            <img :src="popupData.picture" alt="" />
                                            <span class="attandance-status absent"></span>
                                        </div>
                                        <div class="view-attendance-text">
                                            <h2> {{popupData.name}} </h2>
                                            <span class="department"> {{popupData.depName}} , {{popupData.cityName}} </span>
                                            <em class="italic"> {{popupData.date}} <span class="highlight-color"> ( {{popupData.attendanceHour}} worked ) </span> </em>
                                        </div>
                                        <span class="edit-attendance-icon">Edit</span>
                                    </div>
                                    <div class="content-inner p-5">
                                        <div class="attendance-correction mb-5">
                                            <label class="label block-label mb-2"> Time in </label>
                                            <div class="correction-time mb-3">
                                                <div class="correction-time-col">
                                                    <select class="form-control selectpicker custom-select2 selectpicker-popup" data-size="5" name="absentTimeInHour" :id="`absentTimeInHour_${popupData.id}`">
                                                        <option value="" selected>--</option>
                                                        <option v-for="start_time_hour in 12" :value="start_time_hour">
                                                            {{(start_time_hour < 10) ? '0'+start_time_hour : start_time_hour}}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="correction-time-col">
                                                    <select class="form-control selectpicker custom-select2 selectpicker-popup" data-size="5" name="absentTimeInMinute" :id="`absentTimeInMinute_${popupData.id}`">
                                                        <option value="" selected>--</option>
                                                        <option v-for="(start_time_minute,index) in 60" :value="index">
                                                            {{(index < 10) ? '0'+index : index}}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="correction-time-col">
                                                    <select class="form-control selectpicker custom-select2 selectpicker-popup" data-size="5" name="absentTimeInAMPM" :id="`absentTimeInAMPM_${popupData.id}`">
                                                        <option value="" selected>--</option>
                                                        <option value="AM"> AM </option>
                                                        <option value="PM"> PM </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <label class="label block-label mb-2"> Time Out </label>
                                            <div class="correction-time">
                                                <div class="correction-time-col">
                                                    <select class="form-control selectpicker custom-select2 selectpicker-popup" data-size="5" name="absentTimeOutHour" :id="`absentTimeOutHour_${popupData.id}`">
                                                        <option value="" selected>--</option>
                                                        <option v-for="start_time_hour in 12" :value="start_time_hour">
                                                            {{(start_time_hour < 10) ? '0'+start_time_hour : start_time_hour}}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="correction-time-col">
                                                    <select class="form-control selectpicker custom-select2 selectpicker-popup" data-size="5" name="absentTimeOutMinute" :id="`absentTimeOutMinute_${popupData.id}`">
                                                        <option value="" selected>--</option>
                                                        <option v-for="(start_time_minute,index) in 60" :value="index">
                                                            {{(index < 10) ? '0'+index : index}}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="correction-time-col">
                                                    <select class="form-control selectpicker custom-select2 selectpicker-popup" data-size="5" name="absentTimeOutAMPM" :id="`absentTimeOutAMPM_${popupData.id}`">
                                                        <option value="" selected>--</option>
                                                        <option value="AM"> AM </option>
                                                        <option value="PM"> PM </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="popupData.todayEntry.length > 0">
                                            <div class="attendance-history mb-3" v-for="entry in popupData.todayEntry">
                                                <div class="attendance-history-inner">
                                                    <div class="attendance-history-box clearfix">
                                                        <span :class="`image-icon picture-${entry.id} fas fa-image`" @click="toggleImagePopup($event)"></span>
                                                        <p class="attendance-history-text">
                                                            {{entry.status}}
                                                            <span class="bold-text"> {{entry.time}} </span>
                                                            <span class="location">{{entry.location}}</span>
                                                        </p>
                                                    </div>
                                                    <div :class="`attendance-photo attendance-picture-${entry.id} mt-3`">
                                                        <img :src="entry.picture" alt=''/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="" v-else>
                                            <h1 class="text-danger"><b>{{popupData.name}}</b> has not marked their attendance yet.</h1>
                                        </div>
                                    </div>

                                </div>
                                <div class="text-right btn-holder p-3">
                                    <button type="submit" class="btn btn-primary active">Update</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="attendance-head-bar mb-3 clearfix">
                <!-- custom component company setting -->
                <h2 class="float-left"> Today's Attendance </h2>
                <companySettings></companySettings>
                <router-link to="/uploadBulkAttendance" class="btn btn-primary float-right mr-2 active" v-if="attendance_bulk_upload == true"> Attendance bulk upload </router-link>
            </div>
            <div class="row mb-3 normal-ib-space top-widgets-row">
                <div class="col-md-3 widgets-col">
                    <div class="payroll-counter-box attendance-counter-box">
                        <div class="top-box no-bg">
                            <span class="title" title="7" v-if="attendance.totalEmployee != 0">
                                 {{attendance.average}}%
                            </span>
                            <span span class="title" title="7" v-else>------</span>
                            <p> Average Attendance <span v-if="attendance.totalEmployee != 0">({{attendance.presentEmployee}}/{{attendance.totalEmployee}}) </span></p>
                        </div>
                        <div class="foot-box"></div>
                    </div>
                </div>
                <div class="col-md-3 widgets-col">
                    <div class="payroll-counter-box">
                        <div class="top-box no-bg attendance-top-box">
                            <div class="row align-items-center">
                                <div class="col-5">
                                    <span class="time-number float-left">{{attendance.inEmployee}}</span>
                                    <span class="time-text float-right">In</span>
                                </div>
                                <div class="col-2">
                                    <span class="devider"></span>
                                </div>
                                <div class="col-5 text-right">
                                    <span class="time-number highlight-color float-left">{{attendance.outEmployee}}</span>
                                <span class="time-text float-right">Out</span>
                                </div>
                            </div>
                        </div>
                        <div class="foot-box"></div>
                    </div>
                </div>
                <div class="col-md-3 widgets-col">
                    <div class="payroll-counter-box">
                        <div class="top-box no-bg single-chart-box p-1 no-bg">
                            <div id="graph_sm_attendance_average_clock_in" style="height:140px;"></div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 widgets-col">
                    <div class="payroll-counter-box">
                        <div class="top-box no-bg p-0 attendance-top-box">
                            <div class="graph_title">
                                <b>Attendance Breakdown</b>
                            </div>
                            <div id="graph_sm_attendance_breakdown" style="height:105px;"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ticker p-2 mb-3 clearfix">
                <div class="ticker-inner float-left">
                    <marquee behavior="scroll" direction="left" onmouseover="this.stop();" onmouseout="this.start();">
                        <ul class="absentees-list">
                            <li class="absentees-item" v-for="(ab,index) in absentEmployees" :key="index"> {{ab}} </li>
                        </ul>
                    </marquee>
                </div>
                <button type="button" class="btn btn-primary float-right" data-toggle="modal" data-target="#absenteesModal"> View Absentees </button>
            </div>
            <div class="row normal-ib-space mb-3">
                <div class="col">
                    <select class="selectpicker custom-select2" v-model="selected_city_id" @change="filterTable()">
                        <option value="">City</option>
                        <option v-for="city in attendance.cities" :key="city.id" :value="city.id">{{city.name}}</option>
                    </select>
                </div>
                <div class="col">
                    <select class="selectpicker custom-select2" v-model="selected_department_id" @change="filterTable()">
                        <option value="">Department</option>
                        <option v-for="department in attendance.departments" :key="department.id" :value="department.id">{{department.name}}</option>
                    </select>
                </div>
                <div class="col">
                    <select class="selectpicker custom-select2" v-model="selected_branch_id" @change="filterTable()">
                        <option value="">Branch</option>
                        <option v-for="branch in attendance.branches" :key="branch.id" :value="branch.id">{{branch.name}}</option>
                    </select>
                </div>
                <div class="col">
                    <select class="selectpicker custom-select2" v-model="selected_status" @change="filterTable()">
                        <option value="">Status</option>
                        <option value="on_time">On Time</option>
                        <option value="absent">Absent</option>
                        <option value="late">Late</option>
                    </select>
                </div>
                <div class="col">
                    <input type="text" id="customSearch" class="search form-control" placeholder="Search" name="search" v-model="search" @keyup="filterTable()"/>
                </div>
            </div>
            <table id="dt" class="table" style="width:100%">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Wallet Id</th>
                        <th>City</th>
                        <th>Branch</th>
                        <th>Department</th>
                        <th>Arrival</th>
                        <th>Departure</th>
                        <th>Hours</th>
                        <th class="text-center">Action</th>
                    </tr>
                </thead>
                <tbody></tbody>
            </table>
        </template>
        <template v-else-if="today_attendance == null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="today_attendance === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>
<script>
    var gThat = null;
    var myTable = null;
    import companySettings from './companySettings';
    export default {
        components: {
            companySettings
        },
        data() {
            return {
                pData:{},
                absentess: null,
                dtable :null,
                search : null,
                attendance: {
                    AbsenteesEmployee: [],
                    attendances: [],
                    averageClockIn: [],
                    branches: [],
                    cities: [],
                    companyHolidays: [],
                    companySetting: [],
                    departments: [],

                    inEmployee: null,
                    lateEmployee: null,
                    onTimeEmployee: null,
                    outEmployee: null,
                    presentEmployee: null,
                    totalEmployee: null,
                    average: null,
                },

                today_attendance: null,
                update_attendance:null,
                attendance_bulk_upload:null,
                compare_days:[],
                absentEmployees:null,
                url:null,
                shift_id:null,
                absentUrl:null,
                popupData:{
                    todayEntry:[]
                },
                selected_city_id: "",
                selected_department_id: "",
                selected_branch_id: "",
                selected_status: ""
            };
        },

        mounted() {
            gThat = this;
            this.$Progress.start();
            this.can('today_attendance|update_attendance|attendance_bulk_upload').then(result => {
                this.today_attendance = result.today_attendance;
                this.update_attendance = result.update_attendance;
                this.attendance_bulk_upload = result.attendance_bulk_upload;
            }).then(result => {
                // popup
                $(".edit-attendance-icon").click(function(){
                    $('.attendance-correction').fadeToggle();
                    $('.btn-holder').toggleClass('active');
                });
                $(".image-icon").click(function(){
                    $(this).toggleClass('active');
                    $(this).parents('.attendance-history-inner').find('.attendance-photo').slideToggle();
                });
                if(this.today_attendance == true){
                     this.getTodayAttendance();
                     if($('#shiftEnable').val()=='enable'){
                        this.shift_id = $('#shiftId').val();
                        this.url = 'getEmployeeList?shift_id='+this.shift_id;
                        this.absentUrl = 'getAbsentsEmployee?shift_id='+this.shift_id;
                    }else{
                        this.url = 'getEmployeeList';
                        this.absentUrl = "getAbsentsEmployee";
                    }
                }else{
                    this.$Progress.finish();
                }
            });
            EventBus.$on('refreshAttendance', data => {
                this.getTodayAttendance();
            });
        },

        methods: {
            toggleImagePopup(e){
                $(e.target).toggleClass('active');
                $(e.target).parents('.attendance-history-inner').find('.attendance-photo').slideToggle();
            },
            getTodayAttendance() {
                this.$Progress.start();
                axios.get('/api/attendanceToday')
                    .then(res => {
                        if(res.status == 200){
                            this.attendance = res.data;
                            EventBus.$emit('attendanceObject', this.attendance);
                            this.attendance.avg_start_day = moment(res.data.avg_start_day.date).format('D MMM, YYYY');
                            this.attendance.avg_end_day = moment(res.data.avg_end_day.date).format('D MMM, YYYY');
                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                        }
                    }).then(res => {
                        this.averageChart();
                        this.attendanceChart();
                        this.dataTableFunction();
                        this.absenteesEmployeeData();
                        this.getAbsentsEmployee();
                        $('.selectpicker').selectpicker('refresh');


                    })
                    .catch(err => {
                        console.log(err);
                        this.$Progress.fail();
                    });
            },

            updateAttendanceCorrection(id){
                this.$Progress.start();
                var array = [];
                var absentTimeInHour = $('select#absentTimeInHour_'+id).val();
                var absentTimeInMinute = $('select#absentTimeInMinute_'+id).val();
                var absentTimeInAMPM = $('select#absentTimeInAMPM_'+id).val();
                var absentTimeOutHour = $('select#absentTimeOutHour_'+id).val();
                var absentTimeOutMinute = $('select#absentTimeOutMinute_'+id).val();
                var absentTimeOutAMPM = $('select#absentTimeOutAMPM_'+id).val();

                var _token = '{{csrf_token()}}';
                var date = moment(new Date()).format('YYYY-MM-DD');

                if(absentTimeInHour == '' || absentTimeInMinute == '' || absentTimeInAMPM == '' || absentTimeOutHour == '' || absentTimeOutMinute == '' || absentTimeOutAMPM == ''){
                    if(absentTimeInHour != '' && absentTimeInMinute != '' && absentTimeInAMPM != ''){
                        array.push({id:id,absentTimeInHour:absentTimeInHour,absentTimeInMinute:absentTimeInMinute,absentTimeInAMPM:absentTimeInAMPM,absentTimeOutHour:absentTimeOutHour,absentTimeOutMinute:absentTimeOutMinute,absentTimeOutAMPM:absentTimeOutAMPM});
                        axios.post('api/updateAttendaceTimeInOut',{date:date,_token:_token,data:JSON.stringify(array)}).then(res => {
                            if(res.status == 200){
                                $('#view-attendanceModal').modal('hide');
                                myTable.ajax.reload();
                                this.getTodayAttendance();
                                this.showToastBox('success', 'Attendance has been updated');
                            }else{
                                this.showAlertBox('error','Some problem in your form data');
                            }
                        }).catch(err => {
                            this.showAlertBox('error','Some problem in your form data');
                        });
                    }
                    if(absentTimeOutHour != '' && absentTimeOutMinute != '' && absentTimeOutAMPM != ''){
                        array.push({id:id,absentTimeInHour:absentTimeInHour,absentTimeInMinute:absentTimeInMinute,absentTimeInAMPM:absentTimeInAMPM,absentTimeOutHour:absentTimeOutHour,absentTimeOutMinute:absentTimeOutMinute,absentTimeOutAMPM:absentTimeOutAMPM});
                        axios.post('api/updateAttendaceTimeInOut',{date:date,_token:_token,data:JSON.stringify(array)}).then(res => {
                            if(res.status == 200){
                                $('#view-attendanceModal').modal('hide');
                                myTable.ajax.reload();
                                this.getTodayAttendance();
                                this.showToastBox('success', 'Attendance has been updated');
                            }else{
                                this.showAlertBox('error','Some problem in your form data');
                            }
                        }).catch(err => {
                            this.showAlertBox('error','Some problem in your form data');
                        });
                    }
                }else{
                    array.push({id:id,absentTimeInHour:absentTimeInHour,absentTimeInMinute:absentTimeInMinute,absentTimeInAMPM:absentTimeInAMPM,absentTimeOutHour:absentTimeOutHour,absentTimeOutMinute:absentTimeOutMinute,absentTimeOutAMPM:absentTimeOutAMPM});
                    axios.post('api/updateAttendaceTimeInOut',{date:date,_token:_token,data:JSON.stringify(array)}).then(res => {
                        if(res.status == 200){
                            $('#view-attendanceModal').modal('hide');
                            myTable.ajax.reload();
                            this.getTodayAttendance();
                            this.showToastBox('success', 'Attendance has been updated');
                        }else{
                            this.showAlertBox('error','Some problem in your form data');
                        }
                    }).catch(err => {
                        this.showAlertBox('error','Some problem in your form data');
                    });
                }
            },

            filterTable(){
                this.$Progress.start();
                myTable.draw();
                this.$Progress.finish();
            },

            dataTableFunction(){
                let that = this;
                myTable = $("#dt").DataTable({
                        sDom: '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                        processing: true,
					    serverSide: true,
					    ajax: {
                            "url": "api/"+this.url,
                            "type": "POST",
                            "data": function (d) {
                                d.department_id = that.selected_department_id;
                                d.city_id = that.selected_city_id;
                                d.branch_id = that.selected_branch_id;
                                d.status = that.selected_status;
                                d.search = that.search;
						    },
						"headers": window.axios.defaults.headers.common,
						"dataSrc": "records",
					},
                    deferRender: true,
                    columns: [
                            { "data": 0 },
                            { "data": 1 },
                            { "data": 2 },
                            { "data": 3 },
                            { "data": 4 },
                            { "data": 5 },
                            { "data": 6 },
                            { "data": 7 },
                            { "data": 8 }
                        ],

                    order: [[0, 'asc']],
                    "columnDefs": [ 
                        { "orderable": false, "targets": [1,5,6,7,8] }
                    ],
                    "initComplete": (settings, json) => {
                        this.$Progress.finish();
                    }

                    });
            },

            markAttendance(id){
                $(".selectpicker-popup").val('');
                $(".selectpicker-popup").selectpicker("refresh");
                gThat.$Progress.start();
                var date = moment();
                axios.post('api/getAttendancePopupHTML',{userId:id,date:date})
                .then(res => {
                    gThat.popupData = res.data;
                    gThat.$Progress.finish();
                    $('#view-attendanceModal').modal('show');
                })
                .catch(err => {
                    console.log(err);
                });
            },

            getAbsentsEmployee(){
                axios.get('/api/getAbsentsEmployee')
                    .then(res => {
                        if(res.status == 200){
                            this.absentEmployees = res.data.data;
                        }else{
                            this.$Progress.fail();
                        }
                    }).catch(err => {
                        console.log(err);
                        this.$Progress.fail();
                    });
            },

            absenteesEmployeeData(){
                this.absentess = $("#dt-absentees").DataTable({
                    "sDom": '<"row pb-3 view-filter"<"col-md-12 pr-4 pl-4 text-right"f>><"table-holder mb-3"t><"row mb-3 view-pager"<"col-sm-4 pl-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 pr-4 text-right"l>>r',
                    "select": true,
                    "searching":true,
                    "columnDefs": [ 
                        { "orderable": false, "targets": [0 , 2 , 3] },
                        {  className: "select-checkbox", "targets": [0]}
                    ],
                    select: {
                        style:    'multi',
                        selector: 'td:first-child'
                    },
                });
            },

            updateAbsentees(){
                this.$Progress.start();
                var data = this.absentess.rows('.selected').data();
                var array = [];
                for(var i = 0; i < data.length; i++){
                    var user = data[i];
                    var id = $(user[0]).val();
                    var absentTimeInHour = $('#absentTimeInHour'+id).val();
                    var absentTimeInMinute = $('#absentTimeInMinute'+id).val();
                    var absentTimeInAMPM = $('#absentTimeInAMPM'+id).val();
                    var absentTimeOutHour = $('#absentTimeOutHour'+id).val();
                    var absentTimeOutMinute = $('#absentTimeOutMinute'+id).val();
                    var absentTimeOutAMPM = $('#absentTimeOutAMPM'+id).val();
                    if(absentTimeInHour == '' || absentTimeInMinute == '' || absentTimeInAMPM == '' || absentTimeOutHour == '' || absentTimeOutMinute == '' || absentTimeOutAMPM == '' ){
                        this.showAlertBox('error','Some problem in your form data');
                        this.$Progress.finish();
                        return false;
                    }else{
                        array.push({id:id,absentTimeInHour:absentTimeInHour,absentTimeInMinute:absentTimeInMinute,absentTimeInAMPM:absentTimeInAMPM,absentTimeOutHour:absentTimeOutHour,absentTimeOutMinute:absentTimeOutMinute,absentTimeOutAMPM:absentTimeOutAMPM});
                    }
                }
                var _token = '{{csrf_token()}}';
                var date = moment(new Date()).format('YYYY-MM-DD');
                axios.post('api/updateAttendaceTimeInOut', {date:date,_token:_token,data:JSON.stringify(array)})
                .then(res => {
                    if(res.status == 200){
                        this.getTodayAttendance();
                        this.filterTable();
                        this.$Progress.finish();
                        this.showToastBox('success', 'Attendance has been updated');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                   this.showAlertBox('error','Some problem in your form data');
                });
            },

            averageChart(){
                Highcharts.chart('graph_sm_attendance_average_clock_in', {
                    exporting: {
                        enabled: false
                    },
                    chart: {
                        zoomType: 'x'
                    },
                    title: {
                        text: '<b>Average Clock-In</b>',
                        align: 'left',
                        x: 0,
                        y: 25
                    },
                    subtitle: {
                        text: '<span style="color:#000;font-weight:600;font-size:12px">'+this.attendance.avg_start_day+' To '+this.attendance.avg_end_day+'</span>',
                        align: 'left',
                        x: 0,
                        y: 45
                    },
                    credits: false,
                    xAxis: {
                        type: 'datetime'
                    },
                    yAxis: {
                        title: {
                            text: ''
                        },
                        visible: false
                    },
                    legend: {
                        enabled: false
                    },
                    plotOptions: {
                        area: {
                            fillColor: {
                                linearGradient: {
                                    x1: 0,
                                    y1: 0,
                                    x2: 0,
                                    y2: 1
                                },
                                stops: [
                                    [0, Highcharts.getOptions().colors[0]],
                                    [1, Highcharts.Color(Highcharts.getOptions().colors[0]).setOpacity(0).get('rgba')]
                                ]
                            },
                            marker: {
                                radius: 1
                            },
                            lineWidth: 1,
                            states: {
                                hover: {
                                    lineWidth: 1
                                }
                            },
                            threshold: null
                        }
                    },

                    series: [{
                        type: 'area',
                        name: 'Average Time: ',
                        data: this.getDates()

                    }]
                });
            },

            attendanceChart(){
                Highcharts.chart('graph_sm_attendance_breakdown', {
                    exporting: {
                        enabled: false
                    },
                    title: {
                        text: ''
                    },
                    plotOptions: {
                        pie: {
                            size:'150%',
                            innerSize: 50,
                            depth: 0,
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: {
                                    enabled: false
                            }
                        },
                        series: {
                            groupPadding: 0
                        }

                    },
                    credits: false,
                    legend: {
                            align: 'right',
                            verticalAlign: 'middle',
                            layout: 'vertical',
                            x: 0,
                            y: 0
                        },
                    series: [{
                        type: 'pie',
                        dataLabels: {
                                enabled: false
                            },
                        allowPointSelect: true,

                        data: [{
                                name: 'On Time',
                                y: this.attendance.onTimeEmployee,
                                color: '#50ae55'
                            }, {
                                name: 'Late',
                                y: this.attendance.lateEmployee,
                                color:'#4054b2'
                            }, {
                                name: 'Absent',
                                y: this.attendance.AbsenteesEmployee.length,
                                color: '#eb401f'

                        }],
                        showInLegend: true
                    }]
                });
            },

            getDates(){
                var finalDates = [];
                var arr = this.attendance.averageClockIn;
                arr.forEach((el, index)=>{
                    var correctDate = moment(el[0]).utc();
                    var strDate = [correctDate.valueOf() , parseInt(moment(el[0]).format('hh.mm'))];
                    finalDates.push(strDate);
                });
                return finalDates;
            },
        },

        destroyed: function() {
            EventBus.$off('refreshAttendance');
        },
    }
</script>
